"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadManagerState = void 0;
exports.getDisplayStatus = getDisplayStatus;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
/** Derives the display status for a task based on its backend status */
function getDisplayStatus(task) {
    var _a, _b;
    if (task.status === core_api_1.LongRunningTaskStatus.RUNNING) {
        return 'processing';
    }
    if (task.status === core_api_1.LongRunningTaskStatus.FAILED) {
        return 'failed';
    }
    if (task.status === core_api_1.LongRunningTaskStatus.COMPLETED_ERRORS) {
        return 'error';
    }
    if (task.status === core_api_1.LongRunningTaskStatus.COMPLETED_WARNINGS) {
        if (((_a = task.result) === null || _a === void 0 ? void 0 : _a.url) && !task.blobUrl)
            return 'processing';
        return 'warning';
    }
    // COMPLETED — wait for result and blob before showing final status
    if (!((_b = task.result) === null || _b === void 0 ? void 0 : _b.url) || !task.blobUrl) {
        return 'processing';
    }
    return task.downloaded ? 'downloaded' : 'ready';
}
class DownloadManagerState {
    constructor() {
        this.tasks = [];
        this.isPulsing = false;
        this.isPopoverOpen = false;
        /** Number of exports that have been initiated but not yet registered as tasks (covers the network gap) */
        this.pendingExports = 0;
    }
    get activeTasks() {
        return this.tasks.filter((t) => t.status === core_api_1.LongRunningTaskStatus.RUNNING);
    }
    get activeCount() {
        return this.activeTasks.length;
    }
    get hasActiveTasks() {
        return this.activeCount > 0;
    }
    get hasUnseenTasks() {
        return this.tasks.some((t) => !t.seen);
    }
    /** Count of tasks that the user has not yet been notified about (newly added or newly completed) */
    unNotifiedCountForDepartment(departmentId) {
        return this.tasksForDepartment(departmentId).filter((t) => !t.notified).length;
    }
    /** Whether any task in the department has not been interacted with (includes running tasks) */
    hasUnactionedForDepartment(departmentId) {
        return this.tasksForDepartment(departmentId).some((t) => !t.actioned);
    }
    /** Mark all tasks as notified (called when the popover is opened) */
    markAllNotified() {
        for (const task of this.tasks) {
            task.notified = true;
        }
    }
    /**
     * Returns tasks filtered to the given department.
     * The download manager only shows tasks for the current department.
     */
    tasksForDepartment(departmentId) {
        return this.tasks.filter((t) => t.departmentId === departmentId);
    }
    addTask(task) {
        const existing = this.tasks.find((t) => t.taskId === task.taskId);
        if (existing != null) {
            Object.assign(existing, task, { label: `${task.exportType} - ${task.jobName}`, startedAt: existing.startedAt });
            return;
        }
        this.tasks.push(Object.assign(Object.assign({}, task), { label: `${task.exportType} - ${task.jobName}`, seen: true, notified: false, actioned: false, downloaded: false }));
    }
    updateTask(taskId, updates) {
        const task = this.tasks.find((t) => t.taskId === taskId);
        if (task != null) {
            Object.assign(task, updates);
        }
    }
    /** Whether there are any non-running tasks that can be cleared */
    hasClearableItemsForDepartment(departmentId) {
        return this.tasksForDepartment(departmentId).some((t) => t.status !== core_api_1.LongRunningTaskStatus.RUNNING);
    }
    /** Remove all non-running tasks for the given department. Revokes blob URLs and clears poll handles. */
    clearCompleted(departmentId) {
        const toRemove = this.tasks.filter((t) => t.departmentId === departmentId && t.status !== core_api_1.LongRunningTaskStatus.RUNNING);
        for (const task of toRemove) {
            if (task.pollHandle)
                clearTimeout(task.pollHandle);
            if (task.blobUrl)
                URL.revokeObjectURL(task.blobUrl);
        }
        const toRemoveIds = new Set(toRemove.map((t) => t.taskId));
        this.tasks = this.tasks.filter((t) => !toRemoveIds.has(t.taskId));
    }
    /** Stop all polling timeouts and revoke blob URLs. Call on teardown. */
    dispose() {
        for (const task of this.tasks) {
            if (task.pollHandle) {
                clearTimeout(task.pollHandle);
            }
            if (task.blobUrl) {
                URL.revokeObjectURL(task.blobUrl);
            }
        }
    }
}
exports.DownloadManagerState = DownloadManagerState;
tslib_1.__decorate([
    mobx_1.observable
], DownloadManagerState.prototype, "tasks", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DownloadManagerState.prototype, "isPulsing", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DownloadManagerState.prototype, "isPopoverOpen", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DownloadManagerState.prototype, "pendingExports", void 0);
tslib_1.__decorate([
    mobx_1.computed
], DownloadManagerState.prototype, "activeTasks", null);
tslib_1.__decorate([
    mobx_1.computed
], DownloadManagerState.prototype, "activeCount", null);
tslib_1.__decorate([
    mobx_1.computed
], DownloadManagerState.prototype, "hasActiveTasks", null);
tslib_1.__decorate([
    mobx_1.computed
], DownloadManagerState.prototype, "hasUnseenTasks", null);
tslib_1.__decorate([
    mobx_1.action
], DownloadManagerState.prototype, "markAllNotified", null);
tslib_1.__decorate([
    mobx_1.action
], DownloadManagerState.prototype, "addTask", null);
tslib_1.__decorate([
    mobx_1.action
], DownloadManagerState.prototype, "updateTask", null);
tslib_1.__decorate([
    mobx_1.action
], DownloadManagerState.prototype, "clearCompleted", null);
tslib_1.__decorate([
    mobx_1.action
], DownloadManagerState.prototype, "dispose", null);
//# sourceMappingURL=download.manager.state.js.map